export const FORM_CLEAR_ALL = (formId: string) => `${formId.toUpperCase()}_CLEAR_ALL`;
export const FORM_REMOVE_INPUT = (formId: string) => `${formId.toUpperCase()}_REMOVE_INPUT`;
export const FORM_REMOVE_FIELD = (formId: string) => `${formId.toUpperCase()}_REMOVE_FIELD`;
export const FORM_VALIDATE_ALL = (formId: string) => `${formId.toUpperCase()}_VALIDATE_ALL`;
export const FORM_VALUE_CHANGED = (formId: string) => `${formId.toUpperCase()}_VALUE_CHANGED`;
